"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.redirect = void 0;
var constants_1 = require("../service/constants");
var redirectToExternalSite = function (item) {
    if (!item.url)
        return;
    window.location.assign(item.url); // redirect to this url
};
var redirectBackToHome = function (item, push) {
    push({
        pathname: '/',
        query: { curriculaCode: item === null || item === void 0 ? void 0 : item.code },
    });
};
var redirect = function (_a) {
    var item = _a.item, protectedRoutes = _a.protectedRoutes, router = _a.router, onInternalRedirect = _a.onInternalRedirect;
    var isProtectedRoute = protectedRoutes.includes(router.pathname);
    var isExternalItem = constants_1.GLOBAL_NAV_FIXED_ITEMS.all.some(function (fixedItem) { return fixedItem.id === item.id; });
    var backHome = !isProtectedRoute;
    if (isExternalItem)
        return redirectToExternalSite(item);
    if (backHome)
        return redirectBackToHome(item, router.push);
    return onInternalRedirect === null || onInternalRedirect === void 0 ? void 0 : onInternalRedirect(item);
};
exports.redirect = redirect;
